import React from "react";

const Icon = (props) => {
  const PropIcon = props.icon;
  return <PropIcon className={props.className} />;
};

export default Icon;
